




















import Vue from 'vue';
export default Vue.extend(
  {
    name: 'AppDialogOneway',
    props: {
      title: {
        type: String,
        default: '',
      },
      message: {
        type: String,
        default: '',
      },
    },
  },
);
